class CustomSelect extends HTMLElement
{
  // See bundle-creator.liquid for example usage.
	constructor( )
	{
		super( );
	}

	connectedCallback( )
    {
		this.shownName       = this.dataset.shownName;
		this.internalName    = this.dataset.internalName;
		this.value           = null;
    this.openButton      = this.querySelector( ".js-custom-select-open-button" );
		this.selectedDisplay = this.querySelector( ".js-custom-select-selected" );
		this.optionTemplate  = this.querySelector( ".js-custom-select-option-template" );
		this.options         = this.querySelectorAll( ".js-custom-select-option" );
		this.optionsModal    = this.querySelector( ".js-custom-select-modal" );
		this.observer        = new MutationObserver( this.modalObserver.bind( this ) );
		this.observer.observe( this.optionsModal, { childList: true } );
		this.options.forEach( option => { this.setupOption( option ) } );
    document.addEventListener( "click", this.toggleModal.bind( this ) );
    this.selectValue( this.shownName, this.value );
	}

	disconnectedCallback( )
	{
		this.observer.disconnect( );
	}

	setupOption( optionElement )
	{
		optionElement.addEventListener( "click", this.optionClick.bind( this ) );
	}

	optionClick( event )
	{
		const option = event.target;
		this.selectValue( option.dataset.name, option.dataset.value );
		this.dispatchEvent( new Event( "change", { bubbles: true } ) );
	}

	selectValue( name, value )
	{
		this.value                       = value;
		this.selectedDisplay.textContent = name;
	}

	modalObserver( mutations )
	{
		for ( const mutation of mutations )
		{
				if ( mutation.type === 'childList' )
			{
				mutation.addedNodes.forEach( ( node ) =>
				{
					if ( node.nodeType === Node.ELEMENT_NODE )
					{
						this.options = this.querySelectorAll( ".js-custom-select-option" );
						this.setupOption( node );
					}
				});

			}
		}
	}

	clear( )
	{
		this.selectValue( this.dataset.shownName, null );
	}

  toggleModal( event )
  {
    if ( event.target.closest( ".js-custom-select-open-button" ) == this.openButton && !this.optionsModal.parentElement.style.height )
    {
        this.optionsModal.parentElement.style.height = this.optionsModal.parentElement.scrollHeight + 1 + "px";
        this.classList.add( "custom-select--active" );
        this.openButton.ariaExpanded = true;
    }
    else
    {
        this.optionsModal.parentElement.style.height = "";
        this.classList.remove( "custom-select--active" );
        this.openButton.ariaExpanded = false;
    }
  }
}

if ( !customElements.get( "custom-select" ) )
{
    customElements.define( "custom-select", CustomSelect );
}